import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';
import { SFEntityID } from 'utils/types';
import ConnectionsList from '../home/connections/ConnectionsList';
import ConnectionsListPlaceholder from '../home/connections/ConnectionsListPlaceholder';

export default class ProvidersView extends React.Component {

  get content() {
    return this.props.hasFetched
      ? <ConnectionsList connections={this.props.providers} serviceId={this.props.serviceId}/>
      : <ConnectionsListPlaceholder numberOfItems={3} />;
  }

  render() {
    return (
      <div>
        <Title text="Team Members" />
        {this.content}
      </div>
    );
  }
}

ProvidersView.propTypes = {
  providers: PropTypes.array.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  serviceId: SFEntityID
};
